
import {formValidation, plugins} from "./formvalidation_1_8_1/es6/index";
import Bootstrap5 from "./formvalidation_1_8_1/es6/plugins/Bootstrap5";
import selectpicker from './bootstrap-select_v1.14.0-gamma1';

import * as Ladda from 'ladda';
import _ from "underscore";
import './jquery.form';

// import zxcvbn from 'zxcvbn/dist/zxcvbn';
// var zxcvbnGlob;


function ds81_init_autovalidator_form($form, callbackOnSuccess, callbackOnError, callbackOnValidated, callbackOnInvalid, callbackOnValid) {

    // Zxcvbn to global scope:
    // zxcvbnGlob = zxcvbn;



    var form = $form.get(0);

	$form.find('select.rs-select').each(function () {

		let $_this = $(this);

		// Preselect from hash:
		let preselect_topic_id = FE.getHashValue('cf_preselect');
		if(preselect_topic_id)
		{
			let $targetOption = $(this).find('option[data-preselect-id="' + preselect_topic_id + '"]');

			if($targetOption.length > 0){
				$(this).find('option').removeAttr('selected');
				$targetOption.attr('selected', 'selected');
			}
			let $item = $('body #formular').first();
			var scrollDist = $('body').scrollTop() + Math.floor($item.offset().top) - $('header').outerHeight(true) - 8;
			window.scrollTo(0, scrollDist);
		}

		$(this).selectpicker({
			styleBase: 'form-control form-control-lg',
			style: ''
		}).on('changed.bs.select', function () {
			if($(this).selectpicker('val').length)
			{
				$(this).parent().addClass('floating');
			}
			else
			{
				$(this).parent().removeClass('floating');
			}
		}).on('loaded.bs.select', function () {

			if($(this).selectpicker('val').length)
			{
				$(this).parent().addClass('floating');
			}
			else
			{
				$(this).parent().removeClass('floating');
			}

			// Push ARIA label:
			$_this.parent().find('button').attr('aria-label', $_this.attr('aria-label'));
		});



	})

    if($form.hasClass('form-init-done'))
    {
        return false;
    }

    $form.addClass('form-init-done');

    // Add change handler to password meter fields:
    $form.find('input.has-password-meter').on('keydown', function (){
        if($(this).val() != $(this).data('nochange-marker'))
        {
            $(this).attr('data-was-changed', true).data('was-changed', true);
        }
    });

    // Storage for non auto-generated validators:
    var fields = {};

    // Prepare field validator alias listing:
    var aliasListing = {};

    // Parse field list, find alias validators:
    _.each(fields, function (field) {
        if(typeof field.validators !== "undefined")
        {
            _.each(field.validators, function (validator, key) {
                if(typeof validator.alias !== "undefined")
                {
                    aliasListing[key] = validator.alias;
                }
            });
        }
    });

    // Check for auto-generated validation config:
    if(typeof dataStructureValidations !== "undefined")
    {
        fields = $.extend(fields, dataStructureValidations);
    }
    if(typeof $form.data('validations') !== "undefined")
    {
        var restoredFunctionsJson = JSON.parse(JSON.stringify($form.data('validations')), function(k,v){ return typeof v === "string"? (v.startsWith('function')? eval("("+v+")") : v): v});
        fields = $.extend(fields, restoredFunctionsJson);

    }

	var pluginsList = {
		trigger: new plugins.Trigger(),
			bootstrap: new Bootstrap5({
			rowSelector: '.mb-3',
		}),
			alias: new plugins.Alias(aliasListing),
			sequence: new plugins.Sequence({
			enabled: true,
		}),
			declarative: new plugins.Declarative({
			html5Input: false
		}),
			excluded: new plugins.Excluded({
			excluded: function(field, element, elements) {


				// Check if field is hidden:
				if($(element).is(':hidden') && !$(element).next().hasClass('note-editor') && !$(element).parent().hasClass('upload-media-image') && !$(element).hasClass('validate-if-hidden'))
				{
					// console.log('field EX', field);
					return true;
				}

				// Check if field is empty:
				if($(element).data('fv-excluded-if-empty') === true)
				{
					// Enable validation if field has value:
					if($(element).val().length > 0)
					{
						return false;
					}
					else
					{
						return true;
					}
				}
				else
				{
					// Always required.
					return false;
				}
			}
		})
	};

	if($form.attr('method') === "get")
	{
		pluginsList.defaultSubmit = new plugins.DefaultSubmit();
	}
	else
	{
		pluginsList.submitButton = new plugins.SubmitButton();
	}

    var fv = formValidation(
            form,
            {
                fields: fields,
                plugins: pluginsList,
            })
		.on('core.form.invalid', function(event) {

			// Trigger error callback, if set:
			if(typeof callbackOnInvalid === "function")
			{
				callbackOnInvalid($form, event);
			}
		})
		.on('core.field.invalid', function(event) {

			// Trigger error callback, if set:
			if(typeof callbackOnInvalid === "function")
			{
				callbackOnInvalid($form, event);
			}
		})
		.on('core.form.validating', function(event) {

			// Trigger error callback, if set:
			if(typeof callbackOnValidated === "function")
			{
				callbackOnValidated($form, event);
			}
		})
		.on('core.field.validating', function(event) {

			// Trigger error callback, if set:
			if(typeof callbackOnValidated === "function")
			{
				callbackOnValidated($form, event);
			}
		})
		.on('core.field.valid', function(event) {

			// Trigger error callback, if set:
			if(typeof callbackOnValid === "function")
			{
				callbackOnValid($form, event);
			}
		})
        .on('core.form.valid', function() {

			if($form.attr('method') === "get")
			{
				console.log("GET SUBMIT");
				$form.submit();
				return false;
			}


			// Trigger error callback, if set:
			if(typeof callbackOnValid === "function")
			{
				callbackOnValid($form, event);
			}

            var l = Ladda.create( $form.find('.btn-submit.ladda-button').get(0) );
            l.start();
            $form.data('myLadda', l);

            var data = {};

            // Prepare media file listing:
            var mediaList = {};
            $form.find('[class*="upload-media-"]').each(function () {
                var fieldName = $(this).data('listname');
                // console.log('found ' + fieldName);
                mediaList[fieldName] = {};
                var fieldIterator = 0;
                $(this).find('.item-list-target .upload-item').each(function () {
                    var nodeId = $(this).attr('data-itemid');
                    mediaList[fieldName][nodeId] = {};
                    mediaList[fieldName][nodeId] = {
                        'files' : {}
                    },
                        $(this).find('[data-fileid]').each(function () {
                            mediaList[fieldName][nodeId]['files'][fieldIterator ++] = {
                                'fileid': $(this).attr('data-fileid'),
                            };
                        });
                });
            });

            // Add medialist data:
            var data = _.extend(data, {medialist: mediaList});


            // Submit form:
            $form.ajaxSubmit({
                url: $form.attr('action'),
                dataType: 'json',
                method: 'post',
                data: data,
                success: function(responseData, statusText, xhr, $form) {

                    // TODO: Improve whole success handling!


                    if(responseData.result == 'ok')
                    {

                        // Stop ladda if no redirect request is set in response:
                        if(typeof responseData.redirect === "undefined")
                        {
                            l.stop();
                        }

                        // Update page fragments, if some:
                        if(typeof responseData.updateFragments !== "undefined")
                        {
                            for(var i in responseData.updateFragments)
                            {
                                FE.updatePageFragment(i, responseData.updateFragments[i]);
                            }
                        }


                        // Get server message:
                        if(typeof responseData.message !== "undefined")
                        {
                            var messageString = responseData.message;

                            // Show message:
                            if(typeof responseData.redirect === "undefined")
                            {
                                $form.find('.main-form-error-out').addTimedMessage('success', messageString, null, function () {
                                });
                            }
                            else
                            {
                                $form.find('.main-form-error-out').addTimedMessage('success', messageString, null, function () {
                                    location.href = responseData.redirect;
                                });
                            }

                        }
                        else
                        {

                            if(typeof responseData.redirect !== "undefined") {
                                location.href = responseData.redirect;
                            }
                            if(typeof responseData.redirect_from !== "undefined") {
                                location.href = $form.attr(responseData.redirect_from);
                            }
                        }

                        // Trigger success callback, if set:
                        if(typeof callbackOnSuccess === "function")
                        {
                            callbackOnSuccess($form, responseData);
                        }

                        // Form inside .form-content container inside a .form-content-block and .thankyou-content present?
                        // Show thankyou content.
                        if($form.parent().hasClass('form-content') && $form.parent().parent().hasClass('form-content-block') && $form.parent().parent().find('.thankyou-content').length > 0)
                        {
                            $form.parent().addClass('d-none');
                            $form.parent().parent().find('.thankyou-content').removeClass('d-none');
                        }

                    }
                    else {

                        if(typeof responseData.reload !== "undefined") {
                            location.reload();
                            return true;
                        }

                        // Get server error message:
                        if (typeof responseData.errormessage !== "undefined")
                        {
                            // Stop ladda;
                            l.stop();

                            // Get server error message:
                            var errorMessage = responseData.errormessage;

                            // Show message:
                            $form.find('.main-form-error-out').addTimedMessage('danger', errorMessage, 30000);

                        }
                        else if (typeof responseData.fielderrors !== "undefined")
                        {
                            // Stop ladda;
                            l.stop();

                            // Serverseitig erkannte Feldfehler bearbeiten (Fehler anzeigen):
                            for(var i in responseData.fielderrors)
                            {

                                if(responseData.fielderrors[i].length > 0)
                                {
                                    fv
                                    // Update the message option
                                        .updateValidatorOption(
                                            i, 'srv', 'message', responseData.fielderrors[i]
                                        )
                                        // Set the field as invalid
                                        .updateFieldStatus(i, 'Invalid', 'srv');

                                }
                            }

                        }
                        else
                        {
                            l.stop();

                            // Get server error message:
                            var errorMessage = $form.find('.main-form-error-out').data('message-servererror');

                            // Show message:
                            $form.find('.main-form-error-out').addTimedMessage('danger', errorMessage);

                        }

                    }


                },
                error: function(xhr, status, error, $form)
                {
                    // Stop ladda;
                    l.stop();

                    // Get server error message:
                    var errorMessage = $form.find('.main-form-error-out').data('message-servererror');

                    // Show message:
                    $form.find('.main-form-error-out').addTimedMessage('danger', errorMessage);


                    // Trigger error callback, if set:
                    if(typeof callbackOnError === "function")
                    {
                        callbackOnError($form, status, error);
                    }


                }
            });

        });

    $form.data('form-fv', fv);


}

export default (function ds81_init_autovalidator_form($form, callbackOnSuccess, callbackOnError) {
    ds81_init_autovalidator_form($form, callbackOnSuccess, callbackOnError);
}, window.ds81_init_autovalidator_form = ds81_init_autovalidator_form, window.formValidation = formValidation);
